import StickyElement from './directives/stickyElementDirective.js';
import StickyEventsService from './services/stickyEventsService.js';
import './styles/stickyElementDirective.scss';
var moduleName = "stickyElement";
angular.module("stickyElement", []).service("stickyEventsService", StickyEventsService).directive("stickyElement", StickyElement);
export default moduleName;